module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAoCAYAAABnyQNuAAAABGdBTUEAALGPC/xhBQAAAMNJREFUWAntmFEKgCAQRDU6XdfwjHW3vmyW2FIp6MOlFWZB3KS24TUpGnPOawhhQfMeW4TY7F2l6ps1iQjNvfUKdCiyEyhu3ki+6JF/6w7BLXGP/JedSmotQnaYoFirT0WyJAsCtAFtQBtYeYBkSfYkwHnWygkkS7IgQBtY2eA65Chf4GWHW2qSvLWBtzOE+qygVd/j+mnP36NuS7ZHTbMaFGuFlmRJFgRoA3c2wMSf0HZdAMpexZZjTS7PJb3vaz+UDQ6Hn2oys6bsGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon_21.png
// module id = 7IQs
// module chunks = 1